import { getLabel } from "../../../hooks/use-labels";
import {
  formatAmountDetails,
  formatCurrency,
} from "../../../utils/common-utils";

const getPaymentMethod = (transaction) => {
  const { gateway } = transaction;

  return {
    WALLET: getLabel("walletText"),
    PAYSTACK: getLabel("paystackText"),
    COD: getLabel("cashOnDeliveryLabel"),
  }[gateway];
};

const formatRefillType = (cartVolume, product) => {
  return cartVolume === product.volume ? " (Full)" : " (Partial)";
};

export const prepareSummaryList = (summaryInformation) => {
  const {
    cartInfo,
    platformFee,
    applicableDeliveryAmount: applicableDeliveryFee,
    transactions,
  } = summaryInformation;

  const { cartProducts, totalCartAmount, couponDiscount, productsAmountVAT } =
    cartInfo;

    const cartProductsList = cartProducts.map(
    ({ quantity, product, amount, volume }) => ({
      label: `${quantity} X ${product.name}${
        product.containerOption.variableVolume
          ? formatRefillType(volume, product)
          : ""
      }`,
      value: formatCurrency(+amount.value, amount.currency),
    })
  );

  return [
    ...cartProductsList,

    {
      label: getLabel("couponDiscountLabel"),
      value: formatAmountDetails(couponDiscount),
      borderBottom: true,
    },
    {
      label: getLabel("subTotalLabel"),
      value: formatAmountDetails(totalCartAmount),
    },
    {
      label: getLabel("deliveryFeeLabel"),
      value: formatAmountDetails(applicableDeliveryFee),
    },
    {
      label: getLabel("platformFeeLabel"),
      value: formatAmountDetails(platformFee),
    },
    {
      label: `${getLabel("taxOrVATLabel")} Inc.`,
      value: formatAmountDetails(productsAmountVAT),
    },
    ...(transactions
      ? [
          {
            label: `${getLabel("paymentMethodLabel")}`,
            value:
              transactions.length > 0
                ? getPaymentMethod(transactions[0])
                : getLabel("freeLabel"),
          },
        ]
      : []),
  ];
};
